export const cleanRTKQuerySlice = (apiSlice) => {
  if (!apiSlice.queries) return apiSlice;

  const cleanedQueries = {};

  for (const key in apiSlice.queries) {
    const query = apiSlice.queries[key]; // Gets the query value based on the query name (key)
    cleanedQueries[key] =
      query && typeof query === 'object'
        ? {
            ...query,
            data:
              query.data !== undefined
                ? Array.isArray(query.data) // Checks if the data is an array
                  ? `Array(${query.data.length})` // If the data is an array we display the length instead of the full array
                  : '[data hidden]' // For any other data type we just display a placeholder
                : query.data, // If the data is undefined we keep it as is
          }
        : query;
  }

  return {
    ...apiSlice,
    queries: cleanedQueries,
  };
};
